import styled from 'styled-components';
var CtaListContainer = styled.div.withConfig({
  displayName: "CtaListContainer",
  componentId: "sc-1o87l7h-0"
})(["display:flex;"]);
export default CtaListContainer;